//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// eslint-disable-next-line object-curly-newline
import { mdiAlertOctagramOutline, mdiAlarm, mdiPlayBoxOutline, mdiWifi, mdiAlertOutline, mdiAlertCircleOutline } from '@mdi/js'

export default {
  setup() {
    return {
      icons: {
        mdiAlertOctagramOutline,
        mdiAlarm,
        mdiPlayBoxOutline,
        mdiWifi,
        mdiAlertOutline,
        mdiAlertCircleOutline,
      },
    }
  },
}
